import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadStatusService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/leadStatus";

  // newLeadStatus(kitchenMaster: any): Observable<Response[]> {
  //   return this.http.post<Response[]>(`${this.url}`, kitchenMaster)
  // }

  LeadStatus(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllLeadStatusDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  getAllLeadStatusDropDownNew(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/New?type=${type}`);
  }
  leadStatusSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {
    const encodedQuery = encodeURIComponent(query);
    return this.http.get(`${this.url}/filter?search=${encodedQuery}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  syncLeadStatusPageData() {
    return this.http.get(`${this.url}/page/sync`);
  }

  deleteByLeadStatusId(statusId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${statusId}`);
  }


  public responseCache = new Map();

  public getAllLeadStatusDropDownCache(): Observable<any> {

    const leadStatusFromCache = this.responseCache.get(`${this.url}/dropdown`);

    if (leadStatusFromCache) {
      return of(leadStatusFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown`).pipe(
        tap(leadStatus => this.responseCache.set(`${this.url}/dropdown`, leadStatus))
      );
    }

  }


  newLeadStatus(leadStatus: any): Observable<any> {
    return this.http.post<any>(`${this.url}`, leadStatus).pipe(
      tap(() => this.delete())
    );
  }

  delete() {
    this.responseCache.delete(`${this.url}`)
  }


  NameVerified(statusName: any, type: any): Observable<Object> {
    const encodedName = encodeURIComponent(statusName);
    return this.http.get(`${this.url}/${encodedName}/${type}`);
  }


}
